<template>
  <div class="vassoio--wrap">
    <div class="vassoio--bg">
      <picture>
          <source media="(max-width: 860px)" srcset="../assets/vassoio-mobile.svg">
          <source media="(min-width: 861px)" srcset="../assets/vassoio.svg">
          <img src="../assets/vassoio.svg" >
        </picture>
      
      <div class="plates--selection">
        <div class="plate-selected--wrap">
          <img class="rect" src="../assets/rect.png" />
        </div>
        <div class="plate-selected--wrap">
          <img class="rect" src="../assets/rect.png" />
        </div>
        <div class="plate-selected--wrap">
          <img class="rect" src="../assets/rect.png" />
        </div>
        <div class="plate-selected--wrap">
          <img class="rect" src="../assets/rect.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'Vassoio',
    props: ['closeOverlayDishes', 'isOverlay'],
    components:{
    },
  }
</script>

<style lang="scss">
  .vassoio--wrap{
      position: absolute;
      width: 100%;
      bottom: 0;
      text-align: center;
      z-index: 5;
      transform: translate(0 ,40%);
      .vassoio--bg{
        position: relative;
        top: 0;
        width: 60%;
        margin: 0 auto;
        max-width: 650px;
        img{
          display: block;
          width: 100%;
        }
      }
      @media screen and(max-width: 860px){
        transform: translate(0 ,0%);
      }
      .plates--selection{
        position: absolute;
        width: 80%;
        transform: translateX(-50%);
        left: 50%;
        top: 0;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        .plate-selected--wrap{
          position: relative;
          width: 20%;
          margin: 30px 2% 0;
          border-radius: 50%;
          border: 1px solid #000;
          img{
            position: absolute;
            z-index: 6;
            display: block;
            opacity: 0;
            width: 100%;
            top: 0;
            &.rect{
              position: relative;
              z-index: 5;
            }
          }
        }
        @media screen and(max-width: 860px){
          height: 80%;
          top: 10%;
          .plate-selected--wrap{
            width: 35%;
            margin: 10px 2% 0;
          }
        }
      }
    }
</style>